// получаем все задания
export const getTasks = (state) => state.tasks;
